import Vue from "vue";
export const event = new Vue();
/**
 * 对数组原地排序前K位数
 * @param {*} arr
 * @param {*} K
 * @param {*} compareFn 可以传入对比的方法
 */
export function sortTopK(arr, K, compareFn) {
  if (!arr) return;
  if (K > arr.length) return;
  if (typeof compareFn !== "function") {
    compareFn = function (a, b) {
      return a - b;
    };
  }
  partation(arr, 0, arr.length - 1, K, compareFn);
}

function partation(arr, start, end, K, compareFn) {
  if (start >= end) return;
  let i = start;
  let j = start;
  // 选取第中间的数作为对比的值
  let mid = start + ~~((end - start) / 2);
  [arr[mid], arr[end]] = [arr[end], arr[mid]];
  let p = arr[end];
  while (i < end) {
    if (compareFn(arr[i], p) < 0) {
      [arr[i], arr[j]] = [arr[j], arr[i]];
      j++;
    } else if (compareFn(arr[j], p) < 0) {
      j++;
    }
    i++;
  }
  [arr[j], arr[end]] = [arr[end], arr[j]];
  partation(arr, start, j - 1, K, compareFn);
  if (j < K - 1) {
    partation(arr, j + 1, end, K, compareFn);
  }
}
/**
 * 二叉堆
 * isMax {boolean} 是否是大顶堆
 */
class Heap {
  constructor(compareFn, isMax) {
    this.heap = [null];
    this.ratio = isMax ? 1 : -1;
    this.compareFn =
      compareFn ||
      function (a, b) {
        return a - b;
      };
  }
  add(num) {
    const heap = this.heap;
    let i = heap.length;
    heap.push(num);

    while (i > 1) {
      const parent = ~~(i / 2);
      if (this.ratio * this.compareFn(heap[i], heap[parent]) > 0) {
        this.swap(i, parent);
        i = parent;
      } else {
        break;
      }
    }
  }
  init(array) {
    const heap = this.heap;
    Array.prototype.push.apply(heap, array);

    const n = heap.length - 1;
    for (let i = n >> 1; i > 0; i--) {
      this.heapify(i);
    }
  }
  heapify(i) {
    const heap = this.heap;
    const n = this.heap.length - 1;
    if (n < 1) return;
    while (true) {
      const childLeft = i << 1;
      if (childLeft > n) break;
      const childRight = (i << 1) + 1;
      const to =
        !heap[childRight] ||
          this.ratio * this.compareFn(heap[childLeft], heap[childRight]) > 0
          ? childLeft
          : childRight;
      if (this.ratio * this.compareFn(heap[i], heap[to]) >= 0) break;
      this.swap(to, i);
      i = to;
    }
  }
  remove() {
    const heap = this.heap;
    if (heap.length < 1) return null;
    const top = heap[1];
    if (heap.length > 2) {
      heap[1] = heap[heap.length - 1];
      heap.pop();
      this.heapify(1);
    }
    return top;
  }
  peek() {
    return this.heap[1];
  }
  swap(i, j) {
    [this.heap[i], this.heap[j]] = [this.heap[j], this.heap[i]];
  }
}
/**
 * 获取流动数据中前K大的值
 */
export class MaxKHeap {
  constructor(compareFn, k) {
    this.heap = new Heap(compareFn, false);
    this.max = k;
    this.compareFn =
      compareFn ||
      function (a, b) {
        return a - b;
      };
  }
  add(val) {
    if (this.heap.heap.length <= this.max) {
      this.heap.add(val);
      return true;
    }
    if (this.compareFn(val, this.heap.peek()) > 0) {
      this.heap.heap[1] = val;
      this.heap.heapify(1);
      return true;
    }
    return false;
  }
  getAll(handler) {
    handler =
      handler ||
      function (a) {
        return a;
      };
    let res = [];
    let heap = this.heap;
    const max = Math.min(this.max, heap.heap.length - 1);
    for (let i = 0; i < max; i++) {
      res.push(handler(heap.remove()));
    }
    return res;
  }
}

export function isNaN(value) {
  return value !== value;
}
/**
 * 防抖函数
 * @param {*} fn
 * @param {*} delay
 * @param {*} context
 */
export function debounce(fn, delay, context) {
  let timer = null;
  return function (...args) {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      fn.call(context, ...args);
    }, delay);
  };
}

/**
 * 计算两个日期字符串间差的天数
 * @param {*} start
 * @param {*} end
 */
export function calcDateSpan(start, end) {
  const startDate = Date.parse(start);
  const endDate = Date.parse(end);
  const seconds = 24 * 3600 * 1000;
  return ~~((endDate - startDate) / seconds);
}

export function dateOffset(startDate, offsetDay) {
  const date = new Date(startDate);
  date.setDate(date.getDate() + offsetDay);
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) month = `0${month}`;
  if (day < 10) day = `0${day}`;
  return date.getFullYear() + "-" + month + "-" + day;
}

export function syncDateRange(currentRange, dependRange, context) {
  const curDay = calcDateSpan(...currentRange);
  if (dependRange && dependRange.length > 0) {
    const day = calcDateSpan(...dependRange);
    if (curDay !== day) {
      const end = dateOffset(dependRange[0], curDay);
      context.$set(dependRange, 1, end);
    }
  }
}

/**
 * 下载文件
 * @param url 下载接口url
 * @param params url参数，不含ticket
 */
export function downloadFile(url, params) {
  // 表单提交模式
  let _form = document.createElement("form");
  _form.setAttribute("method", "GET");
  _form.setAttribute("action", url);

  for (let _key in params) {
    let _hidden = document.createElement("input");
    _hidden.setAttribute("type", "hidden");
    _hidden.setAttribute("name", _key);
    _hidden.setAttribute("value", params[_key]);
    _form.appendChild(_hidden);
  }

  document.body.appendChild(_form);
  _form.submit();
  document.body.removeChild(_form);

  // a标签模式
  // let _a = document.createElement('a')
  // _a.setAttribute('download', '')
  // // // a.setAttribute('target', '_blank')
  // _a.setAttribute('href', this.createGetUrl(url, params))
  // document.body.appendChild(_a)
  // _a.click()
  // document.body.removeChild(_a)
}
/**
 * map对象转普通对象
 * @param strMap 转化的map对象
 */
export function strMapToObj(strMap) {
  let obj = Object.create(null);
  for (let [k, v] of strMap) {
    obj[k] = v;
  }
  return obj;
}
/**
 * 判断文件是否为图片，视频，文案
 * @param file
 */
export function checkFileType(file) {
  // 图片
  let format = file.name.substring(file.name.lastIndexOf(".") + 1);
  if (/(gif|jpg|jpeg|png|gif|jpg|png)$/.test(format)) {
    console.log("文件为图片");
    return "IMAGE";
  } else if (
    /(wmv|avi|dat|asf|rm|rmvb|ram|mpg|mpeg|3gp|mov|mp4|m4v|dvix|dv|dat|mkv|flv|vob|ram|qt|divx|cpk|fli|flc|mod)$/.test(
      format
    )
  ) {
    console.log("文件为视频");
    return "VIDEO";
  } else {
    console.log("文件为其他");
    return "OTHER";
  }

  // else if (/(txt)$/.test(format)) {
  //   console.log("文件为文本");
  //   return "TXT";
  // }

  // else if (/(xls|xlsx)$/.test(format)) {
  //   console.log("文件为文案");
  //   return "TXT";
  // }
}
import QRCode from "qrcodejs2";
/**
 * 生成二维码
 * @param id 元素id
 * @param ref  元素ref
 * @param url
 */
export function qrcode(id, ref, url) {
  try {
    document.getElementById(id).innerHTML = "";
    let qrcode = new QRCode(ref, {
      width: 150,
      height: 150,
      text: url,
      colorDark: "#000000",
      colorLight: "#ffffff",
      correctLevel: QRCode.CorrectLevel.H,
    });
    // console.log(qrcode)
  } catch (error) {
    console.log(error);
  }
}
// 判断是否PC
export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod",
  ];
  var flag = true;
  for (var i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) != -1) {
      flag = false;
      break;
    }
  }
  return flag;
}

// 获取当前时间
export function getCurrentTime(type) {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let days = date.getDate();
  let hour = date.getHours();
  let minute = date.getMinutes();
  let second = date.getSeconds();

  month = month < 9 ? "0" + month : month;
  days = days < 9 ? "0" + days : days;
  hour = hour < 9 ? "0" + hour : hour;
  minute = minute < 9 ? "0" + minute : minute;
  second = second < 9 ? "0" + second : second;

  return type
    ? `${year}-${month}-${days} ${hour}:${minute}:${second}`
    : `${year}-${month}-${days}`;
}

/*
** 时间戳转换成指定格式日期
** eg. 
** dateFormat(11111111111111, 'Y年m月d日 H时i分')
** → "2322年02月06日 03时45分"
*/
export function timestamp2Date(timestamp, formats) {
  // formats格式包括
  // 1. Y-m-d
  // 2. Y-m-d H:i:s
  // 3. Y年m月d日
  // 4. Y年m月d日 H时i分
  formats = formats || 'Y-m-d';

  let zero = function (value) {
    if (value < 10) {
      return '0' + value;
    }
    return value;
  };

  let myDate = timestamp ? new Date(timestamp) : new Date();

  let year = myDate.getFullYear();
  let month = zero(myDate.getMonth() + 1);
  let day = zero(myDate.getDate());

  let hour = zero(myDate.getHours());
  let minite = zero(myDate.getMinutes());
  let second = zero(myDate.getSeconds());

  return formats.replace(/Y|m|d|H|i|s/ig, function (matches) {
    return ({
      Y: year,
      m: month,
      d: day,
      H: hour,
      i: minite,
      s: second
    })[matches];
  });
}

/*
 *  description: 在vue中使用的防抖函数
 *  param fnName {String}  函数名
 *  param time {Number}    延迟时间
 *  return: 处理后的执行函数
 */
export function VueDebounce(fnName, time) {
  let timeout = null;
  return function () {
    if (timeout) {
      clearTimeout(timeout);
    }

    timeout = setTimeout(() => {
      this[fnName]();
    }, time);
  };
}

/**
 *
 * 生成uuid
 * @export
 * @param {Number} len
 * @param {Number} radix
 * @return {String}
 */
export function uuid(len, radix) {
  var chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    ""
  );
  var uuid = [],
    i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    var r;

    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }
  return uuid.join("");
}

export function getMediaInfo(file) {
  return new Promise((resolve, reject) => {
    let type = checkFileType(file);
    let res = {
      file: file,
      type: type,
      size: file.size,
      contentType: file.type,
    };
    if (type == "IMAGE") {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = (e) => {
        let img = new Image();
        img.src = e.target.result;
        img.onload = () => {
          res.width = img.width;
          res.height = img.height;
          resolve(res);
        };
      };
    } else if (type == "VIDEO" && file.name.split('.').pop().toLocaleLowerCase() == "mp4") {
      var video = document.createElement("video");
      video.src = URL.createObjectURL(file);
      video.onloadedmetadata = () => {
        res.width = video.videoWidth;
        res.height = video.videoHeight;
        res.duration = video.duration;
        resolve(res);
      };
      video.load();
    } else if (type == "OTHER") {
      let ext = file.name
        .split(".")
        .pop()
        .toLocaleLowerCase();
      //txt xls xlxs doc docx
      switch (ext) {
        case "txt":
          res.contentType = "text/plain";
          break;
        case "xls":
          res.contentType = "application/vnd.ms-excel";
          break;
        case "xlsx":
          res.contentType =
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
          break;
        case "doc":
          res.contentType = "application/msword";
          break;
        case "docx":
          res.contentType =
            "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
          break;
        default:
          break;
      }
      resolve(res);
    } else {
      resolve(res);
    }
  });
}
